import React from "react";

const Subtitle = ({ title }) => (
  <h3 className="uk-heading-divider uk-text-left" style={{ marginLeft: 70 }}>
    {title}
  </h3>
);

export default Subtitle;
